// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bombirdier: PokeData = {
  "id": 962,
  "name": "bombirdier",
  "height": 15,
  "weight": 429,
  "base_experience": 243,
  "types": [
    PokeType.FLYING,
    PokeType.DARK
  ],
  "api_moves": [
    "wing-attack",
    "whirlwind",
    "leer",
    "peck",
    "rock-throw",
    "rock-slide",
    "thief",
    "torment",
    "memento",
    "knock-off",
    "rock-tomb",
    "pluck",
    "payback",
    "hone-claws",
    "parting-shot",
    "dual-wingbeat"
  ],
  "moves": [
    "leer",
    "peck",
    "rock-throw",
    "rock-slide",
    "rock-tomb",
    "tailwind",
    "aerial-ace",
    "quash",
    "night-slash",
    "air-slash",
    "bite",
    "crunch",
    "dark-pulse"
  ],
  "evolution_chain": {
    "id": 503,
    "item": null,
    "species": [
      {
        "name": "bombirdier",
        "order": 959,
        "types": [
          PokeType.FLYING,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 125,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
